import React from 'react';
import 'pages/Home/Home.css';
import { ReactComponent as QuoteIcon } from 'assets/svg/quote.svg';
import About from 'pages/Home/components/About/About';
import Button from 'components/Button/Button';
import PuppyCultureLogo from 'assets/img/puppy_culture_logo.png';

function Home() {
    return (
        <div className={'wrapper'}>
            <section className={'landing landing-bg'}>
                <div className={'landing-wrapper'}>
                    <div className={'landing-content'}>
                        <h1 className={'landing-content__title'}>Musical Shepherds</h1>
                        <p className={'landing-content__text'}>Musical from head to tail. </p>
                        <br />
                        <p>
                            The intelligent and downright adorable Miniature American Shepherd
                            captures trophies in agility and obedience and captures hearts at home.
                            These good-natured dogs are affectionate companions and friends for life!
                        </p>
                        <br/>
                        <p>
                            For more pictures and updates follow us on <a href={'https://www.facebook.com/profile.php?id=100084704414201'} target="blank">Facebook</a> and <a href={'https://www.instagram.com/musical_shepherds_mini_aussies'} target="blank">Instagram</a>.
                        </p>
                        <div className={'landing-content__controls'}>
                            <a href={'#about'}>
                                <Button label={'Read More'} />
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section className={'about'} id="about">
                <div className={'about__content'}>
                    <div className={'about__title'}>
                        <h2>WELCOME TO MUSICAL SHEPHERDS MINI AUSSIES!</h2>
                    </div>
                    <div className={'about__text'}>
                        <p data-aos="zoom-out-up">
                            Musical Shepherds is a small, family run, hobby breeder, located on a
                            farm in SE South Dakota.
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            As a responsible breeder, our goal is to breed for quality, temperament,
                            and structure. We strive to raise happy, well socialized, healthy
                            puppies that will be successful in any environment. But also we produce
                            a lifelong friend and companion! We are dedicated to raise pups that are
                            exceptional examples of the breed. Health testing, behavior management,
                            temperament, structure evaluation, and selection of strong genetics are
                            all part of our breeding program. We are committed to improve breed
                            quality.
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            We, at Musical Shepherds, love this breed! We are proud to raise and
                            promote these beautiful dogs. Our parents dogs have been selected from
                            quality breeders based on personality, temperament, genetics,
                            intelligence and beauty. Our dogs are fun-loving, smart, sweet and
                            athletic. They all receive individual attention and training. Our dogs
                            are much loved and well taken care of. They are spoiled by our kids and
                            played with every day! Our dogs bring us joy and lots of smiles! We
                            named our small business Musical Shepherds because of our love for
                            music.
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            As we love dogs, it is our desire that our pups go to warm and caring
                            homes.
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            All of the Mini's in our program are purebred AKC Registered{' '}
                            <span>Miniature American Shepherds</span>. Our dogs/puppies live in the
                            house with us, not in a kennel.
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            The first 12 weeks are critical in a puppy's development. The puppy's
                            brain is a sponge during this period making it the most important and
                            easiest time to shape the way your puppy will live and cope with life.
                            We utilize the "Puppy Culture" program. Puppy Culture is a program from
                            birth to 12 weeks designed to help develop puppies to their full
                            potential. Typically, puppies are not released for sale to a new home
                            until they are 8 weeks old. This initial training helps enrich the
                            human/dog bond.
                        </p>
                        <br />
                        <div className={'about__puppy-culture-logo'}>
                            <a href={'https://www.shoppuppyculture.com'} target="blank">
                                <img
                                    src={PuppyCultureLogo}
                                    alt={'puppy culture logo'}
                                    data-aos="zoom-out-up"
                                />
                            </a>
                        </div>
                        <br />
                        <p data-aos="zoom-out-up">
                            Our puppies will have their tails docked and dewclaws removed. they will
                            be up to date on their shots and dewormed regularly.
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            Our puppies are sold as family pets ONLY on a neutered/spayed contract -
                            even if they are show/breed quality. We reserve the right to refuse the sale of any puppy/dog for any reason.
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            If You are interested in one of our puppies, for initial contact, please email us at <a href="mailto:mypianobabe@yahoo.com">mypianobabe@yahoo.com</a>, message on FB, text <a href="sms:6053877878">(605)660-7878</a>, or call <a href="tel:6053875250">(605)387-5250</a>
                        </p>
                    </div>
                </div>
            </section>
            <section className={'quote '}>
                <div className={'quote-content'}>
                    <QuoteIcon className={'quote__icon-large'} />
                    <div className={'quote-content__title'} data-aos="flip-up">
                        <h2>We Love Dogs</h2>
                        <p>Do You Love Dogs like We do?</p>
                    </div>
                    <div className={'quote-content__text'} data-aos="fade-left">
                        <QuoteIcon className={'quote__icon-small'} />
                        <p>
                            When we saw our first Mini Aussie, we fell in love with the breed. The
                            character, looks, and size were exactly what we wanted.
                        </p>
                    </div>
                </div>
            </section>
            <About />
            <section className={'article'}>
                <div className={'article__content'}>
                    <h2 className={'article__title'}>MINIATURE AMERICAN SHEPHERD</h2>
                    <div>
                        <p data-aos="zoom-out-up">
                            <span>Miniature American Shepherds</span>(Mini American Shepherds) are
                            registered with the American Kennel Club (AKC). Years back, they were
                            registered as <span>Miniature Australian Shepherds</span> (Mini
                            Aussies).
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            <span>Miniature American Shepherd</span> were found and bred in
                            california in the 1960's. These small eye-catching herding dogs are
                            protective, intelligent, loyal and versatile. They have almond-shaped
                            eyes in a variety of colors and one eye may be a different color from
                            the other. Their tails are either naturally short or docked, and they
                            have high-set of triangular ears that hang over toward the front. Mini
                            American Shepherds's medium-length double coat is weather resistant.
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            Body structure <span>The Miniature American Shepherd</span> is a small
                            dog, with the breed standard specifying a height of 14-18 inches (36–46
                            cm) for males and 13-17 inches (33–43 cm) for females. Body structure
                            suggests strength, but not bulkiness, with a clean-cut head and neck
                            proportional to the body. The top line is level from withers to hip
                            joint. The tail may be undocked, a natural bobtail, or may be docked to
                            a length not exceeding three inches.
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            Coat The coat is of medium length and may be straight or wavy, with
                            moderate feathering present on the backs of the legs. Both sexes have a
                            moderate mane and frill, though it is generally more pronounced in males
                            than in females. The undercoat varies according to the climate in which
                            the dog dwells. Recognized coat colors in the breed are black, blue
                            merle, red merle, and red (liver). There are no specified quantities of
                            marbling, flecking, or blotching for merle coats. Tan markings are
                            permissible anywhere around the eyes and face, as well as on the feet,
                            legs, chest, muzzle, underside of the neck and body, under the tail and
                            on the undersides of the ears. White markings are permissible, but
                            limited to the muzzle, cheeks, crown of the head, in a blaze on the
                            head, in a partial or full collar on the neck and on the belly, chest,
                            front legs and hind legs to the hock. White markings should not cover
                            more than 25% of the ear and white body markings outside of the above
                            permitted areas may disqualify the dog from competition.
                        </p>
                        <br />
                        <p data-aos="zoom-out-up">
                            Temperament The <span>Miniature American Shepherd</span> is described as
                            an intelligent working breed with strong instincts for herding and flock
                            guarding. It is easy to train, enthusiastic and persistent toward its
                            work, and is protective, devoted and loyal to its family.{' '}
                            <span>The Miniature American Shepherd</span> is neither shy nor
                            aggressive; any aggressive behavior is a disqualifying characteristic
                            per the AKC.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Home;
